export default [
  {
    path: 'M0 0m184.32 0l655.36 0q184.32 0 184.32 184.32l0 655.36q0 184.32-184.32 184.32l-655.36 0q-184.32 0-184.32-184.32l0-655.36q0-184.32 184.32-184.32Z',
    fill: '#458EE6',
  },
  {
    path: 'M433.152 413.696m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M524.288 413.696m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M615.424 413.696m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M342.016 413.696m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M250.88 413.696m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M433.152 327.68m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M524.288 327.68m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M342.016 327.68m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M525.312 241.664m3.072 0l73.216 0q3.072 0 3.072 3.072l0 67.584q0 3.072-3.072 3.072l-73.216 0q-3.072 0-3.072-3.072l0-67.584q0-3.072 3.072-3.072Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M205.9264 499.82464s-20.5824 3.46112-20.24448 13.1072c-4.57728 26.624-29.40928 253.32736 218.91072 272.64 342.54848 28.96896 417.97632-257.30048 417.97632-257.30048s93.32736 2.32448 115.7632-70.22592c-3.47136-9.216-35.47136-34.73408-100.096-25.01632 0.79872-35.328-44.81024-84.11136-59.2384-84.11136s-57.87648 58.63424-19.95776 139.42784c-1.024 2.9696-21.97504 9.69728-63.77472 11.48928z',
    fill: '#FFFFFF',
  },
]
